'use client'
import {
  SkipNavContent,
  SkipNavLink
} from "./chunk-IZODFAGU.mjs";
export {
  SkipNavContent,
  SkipNavLink
};
//# sourceMappingURL=index.mjs.map